import { NgModule } from '@angular/core';
import { UiUxTableWrapperProviderDirective } from './ui-ux-table-wrapper-provider.directive';

// Global directive — selector is 'cwc-table-wrapper, cwc-table'.
// Applies to ALL <cwc-table-wrapper> and <cwc-table> elements app-wide.
@NgModule({
  declarations: [UiUxTableWrapperProviderDirective],
  exports: [UiUxTableWrapperProviderDirective],
})
export class UiUxTableWrapperProviderDirectiveModule {}
